import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientCentral from "@/pages/ClientCentral";
import Sellers from "@/pages/Sellers";
import Services from "@/pages/Services";
import Sales from "@/pages/Sales";
import Receivables from "@/pages/Receivables";
import Payments from "@/pages/Payments";
import Cash from "@/pages/Cash";
import Payables from "@/pages/Payables";
import Commissions from "@/pages/Commissions";
import Bonuses from "@/pages/Bonuses";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Audit from "@/pages/Audit";
import Contracts from "@/pages/Contracts";
import Forecast from "@/pages/Forecast";
import Orcamento from "@/pages/Orcamento";
import Authors from "@/pages/Authors";
import Portal from "@/pages/Portal";
import Training from "@/pages/Training";
import "@/App.css";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  // Authors are restricted to /portal and /mensagens only
  if (user.role === "autor") {
    const path = window.location.pathname;
    if (path !== "/portal" && path !== "/mensagens") return <Navigate to="/portal" replace />;
  }
  // Prestadores see projetos editoriais and mensagens
  if (user.role === "prestador") {
    const path = window.location.pathname;
    const allowed = path === "/mensagens" || path.startsWith("/projetos-editoriais");
    if (!allowed) return <Navigate to="/projetos-editoriais" replace />;
  }
  return <ErrorBoundary key={window.location.pathname}>{children}</ErrorBoundary>;
}

function LoginGate() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginGate />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/clientes" element={<Protected><Clients /></Protected>} />
          <Route path="/clientes/:id" element={<Protected><ClientCentral /></Protected>} />
          <Route path="/vendedores" element={<Protected><Sellers /></Protected>} />
          <Route path="/servicos" element={<Protected><Services /></Protected>} />
          <Route path="/vendas" element={<Protected><Sales /></Protected>} />
          <Route path="/recebimentos" element={<Protected><Payments /></Protected>} />
          <Route path="/contas-receber" element={<Protected><Receivables /></Protected>} />
          <Route path="/contas-pagar" element={<Protected><Payables /></Protected>} />
          <Route path="/caixa" element={<Protected><Cash /></Protected>} />
          <Route path="/comissoes" element={<Protected><Commissions /></Protected>} />
          <Route path="/bonificacoes" element={<Protected><Bonuses /></Protected>} />
          <Route path="/relatorios" element={<Protected><Reports /></Protected>} />
          <Route path="/usuarios" element={<Protected><Users /></Protected>} />
          <Route path="/auditoria" element={<Protected><Audit /></Protected>} />
          <Route path="/contratos" element={<Protected><Contracts /></Protected>} />
          <Route path="/previsao" element={<Protected><Forecast /></Protected>} />
          <Route path="/orcamento" element={<Protected><Orcamento /></Protected>} />
          <Route path="/treinamento" element={<Protected><Training /></Protected>} />
          <Route path="/autores" element={<Protected><Authors /></Protected>} />
          <Route path="/portal" element={<Protected><Portal /></Protected>} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
